(() => {
  document.querySelectorAll('[data-ww-article]').forEach(root => {
    const body = root.querySelector('[data-ww-article-content]');
    if (!body || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const normalize = s => s.trim().replace(/\s+/g, ' ').toLocaleLowerCase('de');
    const first = body.firstElementChild;
    if (first && /^H[1-3]$/.test(first.tagName) && normalize(first.textContent) === normalize(root.dataset.originalTitle)) first.hidden = true;
    const headings = [...body.querySelectorAll('h2, h3')].filter(h => !h.hidden);
    const toc = root.querySelector('.ww-article__toc');
    headings.forEach((h, i) => {
      if (!h.id) h.id = `ww-lopi-abschnitt-${i + 1}`;
      const li = document.createElement('li');
      const a = document.createElement('a'); a.href = `#${h.id}`; a.textContent = h.textContent;
      li.append(a); toc.querySelector('ul').append(li);
    });
    toc.hidden = headings.length === 0;
  });
})();
